var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"type":"textarea","placeholder":_vm.fieldArguments.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.textarea_defaultValue),callback:function ($$v) {_vm.textarea_defaultValue=$$v},expression:"textarea_defaultValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5131216e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solely-fields/SlsTextarea.vue
// module id = null
// module chunks = 